// Endereço e chave pública do projeto no Supabase. A chave "publishable" é
// feita para ficar dentro do app; a segurança está nas regras do banco (RLS).
// Os testes trocam os dois por variáveis de ambiente (VITE_SUPABASE_URL/KEY).
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://hzsmljfcpxmonvsgsfot.supabase.co';
export const SUPABASE_KEY = import.meta.env.VITE_SUPABASE_KEY || 'sb_publishable_aP94T2jssxG9jZL-_S5aFg_VrE92gXi';

// Preço (decidido pelo titular em 11/10/2026): um plano só, com tudo, por
// caminhão com placa de trator ativa e sem mínimo. Os 2 primeiros caminhões a
// R$ 69,90 por mês cada; do 3º em diante, R$ 59,90. No anual, paga 11 meses.
// Preço de lançamento (era "de fundador"; o nome mudou a pedido do titular em
// 11/10/2026, para não parecer uma aposta): as empresas que assinarem enquanto
// ele valer (até completar 500 caminhões) pagam R$ 49,90 e R$ 39,90 em todos os
// caminhões, nos primeiros 24 meses de assinatura. Quantos lugares faltam só
// aparece depois dos primeiros 200 caminhões (mostrarFaltamDepoisDe). As
// contas ficam em lib/preco.js.
export const PRECO_CAMINHAO = 69.9;
export const PRECO_CAMINHAO_ADICIONAL = 59.9;
export const MESES_PAGOS_NO_ANO = 11;
export const LANCAMENTO = { preco: 49.9, adicional: 39.9, meses: 24, vagas: 500, mostrarFaltamDepoisDe: 200 };
export const DIAS_TESTE = 30;

// Termos de uso e Política de privacidade (E9). A versão é a data do texto:
// mudou o texto, muda a versão. Quem cuida dos dados e recebe os pedidos
// sobre eles (LGPD): o dono do HSA Frota, pelo e-mail do domínio (que chega no Gmail
// dele; trocado em 08/10/2026, a pedido dele). Versão de 11/10/2026: estatísticas
// sem identificação e registros de erro (0.13.0) e, no mesmo dia, o preço novo
// (0.13.1), com o preço de lançamento no lugar do de fundador (0.13.2). Versão
// de 12/10/2026: como a cobrança funciona e o Asaas (E10, 0.14.0), a leitura
// da nota (Anthropic) e as estatísticas (0.15.0 a 0.17.0). Quando o texto muda
// de novo no mesmo dia (ou numa versão que já tem data), vai um número depois
// da data: 2026-10-12.2 trouxe o resumo da semana por e-mail (Resend, 0.18.0).
export const VERSAO_TERMOS = '2026-10-12.2';
export const RESPONSAVEL = { nome: 'Hebert de Souza Alves', cidade: 'Laguna/SC', email: 'contato@hsafrota.com.br' };
// Conta cancelada ou teste que terminou sem assinatura: os dados são apagados
// este tanto de meses depois (do cancelamento ou do fim do teste).
export const MESES_ATE_APAGAR = 6;

// Chave do Google Maps (SOS mecânica: oficinas perto do motorista). É uma
// chave de navegador, limitada no Google Cloud ao endereço do app e a um
// tanto de buscas por dia. Vazia: o SOS mostra só as oficinas de confiança.
export const GOOGLE_MAPS_CHAVE = import.meta.env.VITE_GOOGLE_MAPS_CHAVE || '';
